import { RouteObject } from 'react-router-dom';
import React from 'react';
import { COINS_INFO_ROUTE } from './route.definitions';
import { CoinsInfoPage } from './page';

export const coinsInfoRoutes = (
  el: JSX.Element = <CoinsInfoPage />
): RouteObject => ({
  path: COINS_INFO_ROUTE.ABSOLUTE_PATH,
  element: el,
});
